<article class="w-full flex flex-column bg-black-alpha-10 gap-4 md:gap-6 relative">
  <section class="w-full fadeinup animation-duration-500 ci-bg--blue p-4 md:py-6 text-xl md:text-2xl flex align-items-center gap-2 justify-content-center ci-txt--white">
    <i class="bi bi-database"></i>

    <h3 class="font-semibold">Proyectos</h3>
  </section>

  <section class="w-full ci-main-padding">
    <input type="text" pInputText placeholder="Buscar por nombre" (input)="filterNames($event)"/>
  </section>

  <section class="w-full ci-main-padding flex justify-content-center align-items-center relative mb-4 md:mb-6">
    <section *ngIf="projects.length > 0" class="w-full flex flex-wrap gap-4 md:gap-6">
      <section *ngFor="let project of projects"
        class="w-full sm:w-16rem md:w-20rem lg:w-23rem ci-project-card ci-bg--white shadow-2 flex flex-column border-round-xl overflow-hidden cursor-pointer"
        [routerLink]="['/project/' + project.slug]">
        <section class="w-full h-13rem overflow-hidden">
          <section class="ci-project-card__image w-full h-full bg-cover bg-top overflow-hidden relative"
            [style.background]="getBackgroundLink(project.assets.previewBgUrl)">
            <section class="ci-project-card__overlay-bg w-full h-full absolute top-0 right-0 left-0 bottom-0">
            </section>
          </section>
        </section>

        <section class="w-full p-2">
          <h3 class="ci-ellipsis-2 text-sm font-semibold ci-txt--black-lighten my-0 my-1 flex gap-2 align-items-center text-xl">
            <i class="bi {{project.features[0].icon}} text-xl ci-txt--{{project.color}}"></i>

            {{project.name}}
          </h3>
        </section>
      </section>
    </section>
  </section>
</article>